import { FelaCSS, colors, FelaCSSWithCustomSelectors } from '@bridebook/ui';
import sharedStyles from '@bridebook/web/app-shared/components/supplier/profile-container.style';

type IStyles = ReturnType<typeof sharedStyles> & {
  availableTranslations: (isVenueProfileV2: boolean) => FelaCSS;
  searchBarWrapper: FelaCSS;
  searchBarIcon(loading: boolean): FelaCSS;
  stickyBox: (isVenueProfileV2: boolean) => FelaCSSWithCustomSelectors;
  carouselWrap: (isVenueProfileV2?: boolean) => FelaCSS;
};

const styles = (params: Parameters<typeof sharedStyles>[0] & { isDesktop: boolean }): IStyles => {
  const shared = sharedStyles(params);

  return {
    ...shared,
    carouselWrap: (isVenueProfileV2) => ({
      ...shared.carouselWrap,
      ...(!isVenueProfileV2 && {
        aspectRatio: '3/2',
        overflow: 'hidden',
      }),
    }),

    stickyBox: (isVenueProfileV2) => ({
      minWidthTabletLg: {
        ...(isVenueProfileV2
          ? {
              maxWidth: '715px',
            }
          : {
              // Max dimensions of carousel need to be fixed because of https://bridebook.atlassian.net/browse/LIVE-17033.
              // With 100% width the container is 821.33px. Fractional values are rounded by browser differently,
              // so for those rounding up, there is a small piece of next image visible.
              // For some reason desktopDesign is not working here, so we need to use params.
              maxWidth: '821px',
              maxHeight: '547px',
              borderRadius: 8,
            }),
      },
    }),

    availableTranslations: (isVenueProfileV2) => ({
      position: 'absolute',
      zIndex: 10,

      ...(isVenueProfileV2
        ? {
            ...(params.isDesktop && {
              top: 16,
              right: 4,
            }),

            ...(!params.isDesktop && {
              top: 6,
              right: 12,
            }),
          }
        : {
            ...(params.isDesktop && {
              top: 10,
              right: 0,
            }),

            ...(!params.isDesktop && {
              top: 12,
              right: 10,
            }),
          }),
    }),
    searchBarWrapper: {
      paddingHorizontal: 4,
      paddingTop: 4,
      desktopDesign: {
        paddingHorizontal: 0,
        paddingTop: 0,
        maxWidth: '75%',
      },
    },
    searchBarIcon: (loading) => ({
      backgroundColor: loading ? colors.space40 : colors.indigoCrush,
      borderRadius: '100%',
      minWidth: 32,
      height: 32,
      marginRight: 2,
    }),
  };
};

export default styles;
